import { LaneType } from 'common-types';
import { DateRangeType } from '../baseTypes/DateRangeType';

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ReservableUnitTypesEnum from application-types instead.
 */
export enum ReservableUnitTypesEnum {
  Minutes = 'Minutes',
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ReservableUiTypesEnum from application-types instead.
 */
export enum ReservableUiTypesEnum {
  TimeSlider = 'Date Picker',
  TimeSlots = 'List of Time Slots',
  TimePicker = 'Time Picker',
}

/**
 * This is the settings on a Reservable feature
 */

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use ReservableFeatureRuleType from application-types instead.
 */
export type ReservableFeatureRuleType = {
  // what group role does this rule apply to
  groupRole:
    | {
        _id: string;
      }
    | undefined
    | null;
  // the type of units that unitsAfterNow is in
  unitsAfterNowType: ReservableUnitTypesEnum;
  // the amount of time units after now that is the earliest a user may book
  unitsAfterNow: number;
  // the type of units that unitsBeforeStart is in
  unitsBeforeStartType: ReservableUnitTypesEnum;
  // the max amount of time units before a reservation starts a user may book
  unitsBeforeStart: number;
  // the max slots the user can book
  maxSlots: number;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use ReservableFeatureProperties from application-types instead.
 */
export type ReservableFeatureProperties = {
  _version: undefined | 2;
  // the type of units that units is in
  unitType: ReservableUnitTypesEnum;
  units: number;
  uiType: ReservableUiTypesEnum;
  maxQuantityPerSlot: number;
  maxQuantityPerSlotPerUser: number;
  dateRange: DateRangeType | null;
  mainRule: ReservableFeatureRuleType;
  rules: ReservableFeatureRuleType[];
  useCustomTimeSlots?: boolean;
  useWaitlist?: LaneType.Boolean;
  customTimeSlots?: LaneType.TimeRange[];
  splitReservation?: boolean;
  splitReservationSlots?: number;
  bufferTime?: LaneType.BufferTime;
  relatedSpaces?: LaneType.RelatedSpaces | null;
  userNotes?: LaneType.UserNotes;
};
